import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { AjaxService } from '../../../services/ajax.service';

interface IGoTraegerResult {
  name: string;
  traegerId?: number;
}

@Component({
  selector: 'cz-go-traeger',
  templateUrl: './go-traeger.component.html',
  styleUrls: ['./go-traeger.component.css'],
  standalone: false,
})
export class GoTraegerComponent implements OnInit {
  @Input() id?: number;

  result: IGoTraegerResult;

  constructor(private router: Router, private ajaxService: AjaxService) {}

  ngOnInit() {
    this.load();
  }

  load() {
    if (!this.id) {
        this.result = null;
    } else {
      this.ajaxService
        .get<IGoTraegerResult>('api/Traeger/GetTraegerForGo/' + this.id)
        .subscribe((response) => {
          this.result = response;
        });
    }
  }

  onClickGo() {
    this.router.navigate(['/traeger/edit', this.result.traegerId]);
  }
}
